import React from 'react'

export default function Products(){
  const openPDF = (pdfPath) => {
    window.open(pdfPath, "_blank");
  };

  return (
    <main>
      {/* Page Header */}
      <section className="container-fluid page-banner black-banner" style={{background: 'url(/img/test5.jpg) center no-repeat', height: '400px', backgroundSize: 'cover', backgroundPositionY: '54%'}}>
        <div className="container py-5">
          <div className="row align-items-center py-4">
            <div className="col-md-6 text-center text-md-left">
              <h1 className="display-4 mb-4 mb-md-0 text-secondary">Product</h1>
            </div>
            {/* <div className="col-md-6 text-center text-md-right">
              <div className="d-inline-flex align-items-center">
                <a className="btn btn-sm btn-outline-light" href="/">Home</a>
                <i className="fas fa-angle-double-right text-light mx-2"></i>
                <a className="btn btn-sm btn-outline-light disabled" href="">Product</a>
              </div>
            </div> */}
          </div>
        </div>
      </section>

      {/* Company Description */}
      <section className="py-5" style={{backgroundColor: '#f5f5f0'}}>
        <div className="container">
          <div className="row">
            <div className="col-12">
              <p className="lead text-muted">
                The search for optimum health is the main driver at LAKULISH PHARMACEUTICALS. As a forward-looking pharmaceutical company, LAKULISH spearheads the development, production and marketing of an array of speciality medicines, active pharmaceutical ingredients and novel therapeutic entities with over 500 products available in different dosage forms having exclusive packaging.
              </p>
              <p className="lead text-muted">
                Our integrated business model enables us to cater to business opportunities throughout the value chain, from research to delivery of drug across therapeutic segments. In its effort to foster well-being in the communities, the company enhances the quality of life through research and development, manufacturing and marketing of pharmaceutical products.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Featured Products Carousel */}
      {/* <section className="py-5">
        <div className="container">
          <div className="row align-items-end mb-4">
            <div className="col-lg-6">
              <h1 className="section-title mb-3" style={{color: '#5d4037'}}>Our Products</h1>
            </div>
            <div className="col-lg-6">
              <p className="text-muted mb-3">Discover our range of pharmaceutical products</p>
            </div>
          </div>

          <div className="row">
            <div className="col-12">
              <div className="featured-products-grid">
                <div className="row g-4">
                  <div className="col-lg-3 col-md-6">
                    <div className="card border-0 shadow-lg h-100">
                      <img src="/img/AMLOLISH 5.jpg" className="card-img-top" alt="AMLOLISH-5" style={{height: '300px', objectFit: 'cover'}} />
                      <div className="card-body text-center">
                        <h5 className="card-title font-weight-bold" style={{color: '#5d4037'}}>AMLOLISH-5</h5>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-3 col-md-6">
                    <div className="card border-0 shadow-lg h-100">
                      <img src="/img/AMLOLISH 10.jpg" className="card-img-top" alt="AMLOLISH-10" style={{height: '300px', objectFit: 'cover'}} />
                      <div className="card-body text-center">
                        <h5 className="card-title font-weight-bold" style={{color: '#5d4037'}}>AMLOLISH-10</h5>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-3 col-md-6">
                    <div className="card border-0 shadow-lg h-100">
                      <img src="/img/FeLish.jpg" className="card-img-top" alt="FeLish" style={{height: '300px', objectFit: 'cover'}} />
                      <div className="card-body text-center">
                        <h5 className="card-title font-weight-bold" style={{color: '#5d4037'}}>FeLish</h5>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-3 col-md-6">
                    <div className="card border-0 shadow-lg h-100">
                      <img src="/img/OMELISH.jpg" className="card-img-top" alt="OMELISH-20" style={{height: '300px', objectFit: 'cover'}} />
                      <div className="card-body text-center">
                        <h5 className="card-title font-weight-bold" style={{color: '#5d4037'}}>OMELISH-20</h5>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section> */}

      {/* Product Categories */}
      <section className="py-5" style={{backgroundColor: '#f5f5f0'}}>
        <div className="container">
          <div className="text-center mb-5">
            <h2 className="display-4 font-weight-bold mb-4" style={{color: '#5d4037'}}>List of Products</h2>
          </div>

          <div className="row g-4">
            {/* Oncology */}
            <div className="col-lg-4 col-md-6 mb-4">
              <div className="card border-0 shadow-sm h-100">
                <img className="card-img-top rounded" src="/img/1. Nutraceuticals.jpeg" alt="Nutraceuticals" style={{height: '200px', objectFit: 'cover', cursor: 'pointer'}} onClick={() => openPDF('/lib/1. Nutraceuticals.pdf')} />
                <div className="card-body text-center">
                  <h6 className="card-title font-weight-bold mb-3" style={{color: '#5d4037'}}>Nutraceuticals</h6>
                  <button className="btn btn-primary btn-sm" onClick={() => openPDF('/lib/1. Nutraceuticals.pdf')}>Read More</button>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 mb-4">
              <div className="card border-0 shadow-sm h-100">
                <img className="card-img-top rounded" src="/img/2. Cosmetics.jpg" alt="Cosmetics" style={{height: '200px', objectFit: 'cover', cursor: 'pointer'}} onClick={() => openPDF('/lib/2. Cosmetics.pdf')} />
                <div className="card-body text-center">
                  <h6 className="card-title font-weight-bold mb-3" style={{color: '#5d4037'}}>Cosmetics</h6>
                  <button className="btn btn-primary btn-sm" onClick={() => openPDF('/lib/2. Cosmetics.pdf')}>Read More</button>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 mb-4">
              <div className="card border-0 shadow-sm h-100">
                <img className="card-img-top rounded" src="/img/3. Medical Devices.jpg" alt="Medical Devices" style={{height: '200px', objectFit: 'cover', cursor: 'pointer'}} onClick={() => openPDF('/lib/3. Medical Devices.pdf')} />
                <div className="card-body text-center">
                  <h6 className="card-title font-weight-bold mb-3" style={{color: '#5d4037'}}>Medical Devices</h6>
                  <button className="btn btn-primary btn-sm" onClick={() => openPDF('/lib/3. Medical Devices.pdf')}>Read More</button>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 mb-4">
              <div className="card border-0 shadow-sm h-100">
                <img className="card-img-top rounded" src="/img/4. Gloves.jpg" alt="Gloves" style={{height: '200px', objectFit: 'cover', cursor: 'pointer'}} onClick={() => openPDF('/lib/4. Gloves.pdf')} />
                <div className="card-body text-center">
                  <h6 className="card-title font-weight-bold mb-3" style={{color: '#5d4037'}}>Gloves</h6>
                  <button className="btn btn-primary btn-sm" onClick={() => openPDF('/lib/4. Gloves.pdf')}>Read More</button>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 mb-4">
              <div className="card border-0 shadow-sm h-100">
                <img className="card-img-top rounded" src="/img/5. Hygiene Products.jpg" alt="Hygiene Products" style={{height: '200px', objectFit: 'cover', cursor: 'pointer'}} onClick={() => openPDF('/lib/5. Hygiene.pdf')} />
                <div className="card-body text-center">
                  <h6 className="card-title font-weight-bold mb-3" style={{color: '#5d4037'}}>Hygiene Products</h6>
                  <button className="btn btn-primary btn-sm" onClick={() => openPDF('/lib/5. Hygiene.pdf')}>Read More</button>
                </div>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 mb-4">
              <div className="card border-0 shadow-sm h-100">
                <img className="card-img-top rounded" src="/img/6. WHO-CoPP Product List.jpg" alt="WHO-CoPP Product" style={{height: '200px', objectFit: 'cover', cursor: 'pointer'}} onClick={() => openPDF('/lib/6. WHO-CoPP Product List.pdf')} />
                <div className="card-body text-center">
                  <h6 className="card-title font-weight-bold mb-3" style={{color: '#5d4037'}}>WHO-CoPP Product</h6>
                  <button className="btn btn-primary btn-sm" onClick={() => openPDF('/lib/6. WHO-CoPP Product List.pdf')}>Read More</button>
                </div>
              </div>
            </div>

            {/* Analgesic/Anti-Pyretic/Anti-Inflammatory/NSAIDs */}
            {/* <div className="col-lg-4 col-md-6 mb-4">
              <div className="card border-0 shadow-sm h-100">
                <img className="card-img-top rounded" src="/img/Product2.jpg" alt="Analgesic/Anti-Pyretic/Anti-Inflammatory/NSAIDs" style={{height: '200px', objectFit: 'cover', cursor: 'pointer'}} onClick={() => openPDF('/lib/Analgesic_Anti-Pyretic_Anti-Inflammatory_NSAIDs.pdf')} />
                <div className="card-body text-center">
                  <h6 className="card-title font-weight-bold mb-3" style={{color: '#5d4037'}}>Analgesic/Anti-Pyretic/Anti-Inflammatory/NSAIDs</h6>
                  <button className="btn btn-primary btn-sm" onClick={() => openPDF('/lib/Analgesic_Anti-Pyretic_Anti-Inflammatory_NSAIDs.pdf')}>Read More</button>
                </div>
              </div>
            </div> */}

            {/* Anti-Cold/Anti-Allergic/Anti-Asthamatic */}
            {/* <div className="col-lg-4 col-md-6 mb-4">
              <div className="card border-0 shadow-sm h-100">
                <img className="card-img-top rounded" src="/img/Product3.jpg" alt="Anti-Cold/Anti-Allergic/Anti-Asthamatic" style={{height: '200px', objectFit: 'cover', cursor: 'pointer'}} onClick={() => openPDF('/lib/Anti-Cold_Anti-Allergic_Anti-Asthamatic.pdf')} />
                <div className="card-body text-center">
                  <h6 className="card-title font-weight-bold mb-3" style={{color: '#5d4037'}}>Anti-Cold/Anti-Allergic/Anti-Asthamatic</h6>
                  <button className="btn btn-primary btn-sm" onClick={() => openPDF('/lib/Anti-Cold_Anti-Allergic_Anti-Asthamatic.pdf')}>Read More</button>
                </div>
              </div>
            </div> */}

            {/* Antibiotics/Anti-Viral/β-Lactum */}
            {/* <div className="col-lg-4 col-md-6 mb-4">
              <div className="card border-0 shadow-sm h-100">
                <img className="card-img-top rounded" src="/img/Product4.jpg" alt="Antibiotics/Anti-Viral/β-Lactum" style={{height: '200px', objectFit: 'cover', cursor: 'pointer'}} onClick={() => openPDF('/lib/Antibiotics_Anti-Viral-Lactum.pdf')} />
                <div className="card-body text-center">
                  <h6 className="card-title font-weight-bold mb-3" style={{color: '#5d4037'}}>Antibiotics/Anti-Viral/β-Lactum</h6>
                  <button className="btn btn-primary btn-sm" onClick={() => openPDF('/lib/Antibiotics_Anti-Viral-Lactum.pdf')}>Read More</button>
                </div>
              </div>
            </div> */}

            {/* Cephalosporin */}
            {/* <div className="col-lg-4 col-md-6 mb-4">
              <div className="card border-0 shadow-sm h-100">
                <img className="card-img-top rounded" src="/img/Product5.jpg" alt="Cephalosporin" style={{height: '200px', objectFit: 'cover', cursor: 'pointer'}} onClick={() => openPDF('/lib/Cephalosporin.pdf')} />
                <div className="card-body text-center">
                  <h6 className="card-title font-weight-bold mb-3" style={{color: '#5d4037'}}>Cephalosporin</h6>
                  <button className="btn btn-primary btn-sm" onClick={() => openPDF('/lib/Cephalosporin.pdf')}>Read More</button>
                </div>
              </div>
            </div> */}

            {/* Anti-Fungal */}
            {/* <div className="col-lg-4 col-md-6 mb-4">
              <div className="card border-0 shadow-sm h-100">
                <img className="card-img-top rounded" src="/img/Product6.jpg" alt="Anti-Fungal" style={{height: '200px', objectFit: 'cover', cursor: 'pointer'}} onClick={() => openPDF('/lib/Anti-Fungal.pdf')} />
                <div className="card-body text-center">
                  <h6 className="card-title font-weight-bold mb-3" style={{color: '#5d4037'}}>Anti-Fungal</h6>
                  <button className="btn btn-primary btn-sm" onClick={() => openPDF('/lib/Anti-Fungal.pdf')}>Read More</button>
                </div>
              </div>
            </div> */}

            {/* GIT Products */}
            {/* <div className="col-lg-4 col-md-6 mb-4">
              <div className="card border-0 shadow-sm h-100">
                <img className="card-img-top rounded" src="/img/Product7.jpg" alt="GIT Products" style={{height: '200px', objectFit: 'cover', cursor: 'pointer'}} onClick={() => openPDF('/lib/GIT Products.pdf')} />
                <div className="card-body text-center">
                  <h6 className="card-title font-weight-bold mb-3" style={{color: '#5d4037'}}>GIT Products</h6>
                  <button className="btn btn-primary btn-sm" onClick={() => openPDF('/lib/GIT Products.pdf')}>Read More</button>
                </div>
              </div>
            </div> */}

            {/* Cardiac/Anti-Hypertensive/Diuretic/Anti-Platelet/Coagulants/Anti-Coagulants */}
            {/* <div className="col-lg-4 col-md-6 mb-4">
              <div className="card border-0 shadow-sm h-100">
                <img className="card-img-top rounded" src="/img/Product8.jpg" alt="Cardiac/Anti-Hypertensive/Diuretic/Anti-Platelet/Coagulants/Anti-Coagulants" style={{height: '200px', objectFit: 'cover', cursor: 'pointer'}} onClick={() => openPDF('/lib/Cardiac_Anti-Hypertensive_Diuretic_Anti-Platelet_Coagulants_Anti-Coagulants.pdf')} />
                <div className="card-body text-center">
                  <h6 className="card-title font-weight-bold mb-3" style={{color: '#5d4037'}}>Cardiac/Anti-Hypertensive/Diuretic/Anti-Platelet/Coagulants/Anti-Coagulants</h6>
                  <button className="btn btn-primary btn-sm" onClick={() => openPDF('/lib/Cardiac_Anti-Hypertensive_Diuretic_Anti-Platelet_Coagulants_Anti-Coagulants.pdf')}>Read More</button>
                </div>
              </div>
            </div> */}

            {/* Anti-Diabetic */}
            {/* <div className="col-lg-4 col-md-6 mb-4">
              <div className="card border-0 shadow-sm h-100">
                <img className="card-img-top rounded" src="/img/Product9.jpg" alt="Anti-Diabetic" style={{height: '200px', objectFit: 'cover', cursor: 'pointer'}} onClick={() => openPDF('/lib/Anti-Diabetic.pdf')} />
                <div className="card-body text-center">
                  <h6 className="card-title font-weight-bold mb-3" style={{color: '#5d4037'}}>Anti-Diabetic</h6>
                  <button className="btn btn-primary btn-sm" onClick={() => openPDF('/lib/Anti-Diabetic.pdf')}>Read More</button>
                </div>
              </div>
            </div> */}

            {/* Anti-Psychotic/Anti-Convulsant/Anti-Depressant */}
            {/* <div className="col-lg-4 col-md-6 mb-4">
              <div className="card border-0 shadow-sm h-100">
                <img className="card-img-top rounded" src="/img/Product10.jpg" alt="Anti-Psychotic/Anti-Convulsant/Anti-Depressant" style={{height: '200px', objectFit: 'cover', cursor: 'pointer'}} onClick={() => openPDF('/lib/Anti-Psychotic_Anti-Convulsant_Anti-Depressant.pdf')} />
                <div className="card-body text-center">
                  <h6 className="card-title font-weight-bold mb-3" style={{color: '#5d4037'}}>Anti-Psychotic/Anti-Convulsant/Anti-Depressant</h6>
                  <button className="btn btn-primary btn-sm" onClick={() => openPDF('/lib/Anti-Psychotic_Anti-Convulsant_Anti-Depressant.pdf')}>Read More</button>
                </div>
              </div>
            </div> */}

            {/* Vitamins/Minerals/Iron */}
            {/* <div className="col-lg-4 col-md-6 mb-4">
              <div className="card border-0 shadow-sm h-100">
                <img className="card-img-top rounded" src="/img/Product11.jpg" alt="Vitamins/Minerals/Iron" style={{height: '200px', objectFit: 'cover', cursor: 'pointer'}} onClick={() => openPDF('/lib/Vitamins_Minerals_Iron.pdf')} />
                <div className="card-body text-center">
                  <h6 className="card-title font-weight-bold mb-3" style={{color: '#5d4037'}}>Vitamins/Minerals/Iron</h6>
                  <button className="btn btn-primary btn-sm" onClick={() => openPDF('/lib/Vitamins_Minerals_Iron.pdf')}>Read More</button>
                </div>
              </div>
            </div> */}

            {/* Hormones */}
            {/* <div className="col-lg-4 col-md-6 mb-4">
              <div className="card border-0 shadow-sm h-100">
                <img className="card-img-top rounded" src="/img/Product12.jpg" alt="Hormones" style={{height: '200px', objectFit: 'cover', cursor: 'pointer'}} onClick={() => openPDF('/lib/Hormones.pdf')} />
                <div className="card-body text-center">
                  <h6 className="card-title font-weight-bold mb-3" style={{color: '#5d4037'}}>Hormones</h6>
                  <button className="btn btn-primary btn-sm" onClick={() => openPDF('/lib/Hormones.pdf')}>Read More</button>
                </div>
              </div>
            </div> */}

            {/* Ophthalmic */}
            {/* <div className="col-lg-4 col-md-6 mb-4">
              <div className="card border-0 shadow-sm h-100">
                <img className="card-img-top rounded" src="/img/Product13.jpg" alt="Ophthalmic" style={{height: '200px', objectFit: 'cover', cursor: 'pointer'}} onClick={() => openPDF('/lib/Ophthalmic.pdf')} />
                <div className="card-body text-center">
                  <h6 className="card-title font-weight-bold mb-3" style={{color: '#5d4037'}}>Ophthalmic</h6>
                  <button className="btn btn-primary btn-sm" onClick={() => openPDF('/lib/Ophthalmic.pdf')}>Read More</button>
                </div>
              </div>
            </div> */}

            {/* General Anesthetics */}
            {/* <div className="col-lg-4 col-md-6 mb-4">
              <div className="card border-0 shadow-sm h-100">
                <img className="card-img-top rounded" src="/img/Product14.jpg" alt="General Anesthetics" style={{height: '200px', objectFit: 'cover', cursor: 'pointer'}} onClick={() => openPDF('/lib/General Anasthetics.pdf')} />
                <div className="card-body text-center">
                  <h6 className="card-title font-weight-bold mb-3" style={{color: '#5d4037'}}>General Anesthetics</h6>
                  <button className="btn btn-primary btn-sm" onClick={() => openPDF('/lib/General Anasthetics.pdf')}>Read More</button>
                </div>
              </div>
            </div> */}

            {/* Erectile/Dysfunction */}
            {/* <div className="col-lg-4 col-md-6 mb-4">
              <div className="card border-0 shadow-sm h-100">
                <img className="card-img-top rounded" src="/img/Product15.jpg" alt="Erectile Dysfunction" style={{height: '200px', objectFit: 'cover', cursor: 'pointer'}} onClick={() => openPDF('/lib/Erectile Dysfunction.pdf')} />
                <div className="card-body text-center">
                  <h6 className="card-title font-weight-bold mb-3" style={{color: '#5d4037'}}>Erectile Dysfunction</h6>
                  <button className="btn btn-primary btn-sm" onClick={() => openPDF('/lib/Erectile Dysfunction.pdf')}>Read More</button>
                </div>
              </div>
            </div> */}

            {/* External Preparation */}
            {/* <div className="col-lg-4 col-md-6 mb-4">
              <div className="card border-0 shadow-sm h-100">
                <img className="card-img-top rounded" src="/img/Product16.jpg" alt="External Preparation" style={{height: '200px', objectFit: 'cover', cursor: 'pointer'}} onClick={() => openPDF('/lib/External Preparation.pdf')} />
                <div className="card-body text-center">
                  <h6 className="card-title font-weight-bold mb-3" style={{color: '#5d4037'}}>External Preparation</h6>
                  <button className="btn btn-primary btn-sm" onClick={() => openPDF('/lib/External Preparation.pdf')}>Read More</button>
                </div>
              </div>
            </div> */}


            {/* Metered/Dose/Inhaler */}
            {/* <div className="col-lg-4 col-md-6 mb-4">
              <div className="card border-0 shadow-sm h-100">
                <img className="card-img-top rounded" src="/img/Product18.jpg" alt="MDIs/DPIs/Respules" style={{height: '200px', objectFit: 'cover', cursor: 'pointer'}} onClick={() => openPDF('/lib/Metered Dose Inhaler.pdf')} />
                <div className="card-body text-center">
                  <h6 className="card-title font-weight-bold mb-3" style={{color: '#5d4037'}}>MDIs/DPIs/Respules</h6>
                  <button className="btn btn-primary btn-sm" onClick={() => openPDF('/lib/Metered Dose Inhaler.pdf')}>Read More</button>
                </div>
              </div>
            </div> */}
          </div>
        </div>
      </section>

      {/* Innovation Note */}
      <section className="py-5" style={{backgroundColor: '#f5f5f0'}}>
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="text-center">
                <div className="card border-0 shadow-sm" style={{backgroundColor: 'white'}}>
                  <div className="card-body">
                    <i className="fas fa-lightbulb fa-3x text-warning mb-3"></i>
                    <h4 className="card-title mb-3" style={{color: '#5d4037'}}>Innovation is Key to Success</h4>
                    <p className="text-muted mb-0">
                      Note: These are some of the formulations from our diverse range of products. We also develop products as per client's requirement because we believe that Innovation is key to success.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  )
}
